import { render, staticRenderFns } from "./GameContainer.vue?vue&type=template&id=0fc5a8ae&scoped=true"
import script from "./GameContainer.vue?vue&type=script&lang=js"
export * from "./GameContainer.vue?vue&type=script&lang=js"
import style0 from "./GameContainer.vue?vue&type=style&index=0&id=0fc5a8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc5a8ae",
  null
  
)

export default component.exports